(function() {
  console.log('Filter search script loaded');
  
  const searchInputs = document.querySelectorAll('[data-filter-search]');
  console.log('Found search inputs:', searchInputs.length);
  
  searchInputs.forEach(input => {
    const filterType = input.getAttribute('data-filter-search');
    console.log('Initializing search for:', filterType);
    
    const items = document.querySelectorAll(`[data-filter-item="${filterType}"]`);
    console.log(`Found ${items.length} items for filter type: ${filterType}`);
    items.forEach(item => {
      console.log('Item:', item.getAttribute('data-filter-value'));
    });
    
    input.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase();
      console.log('Searching for:', searchTerm);
      
      const filterItems = document.querySelectorAll(`[data-filter-item="${filterType}"]`);
      let shown = 0;
      
      filterItems.forEach(item => {
        const value = item.getAttribute('data-filter-value').toLowerCase();
        if (value.includes(searchTerm)) {
          item.style.display = '';
          shown++;
        } else {
          item.style.display = 'none';
        }
      });
      console.log(`Showing ${shown} items`);
    });
  });
})();